import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-stock',
  standalone: false,
  
  templateUrl: './inventory-stock.component.html',
  styles: ``
})
export class InventoryStockComponent {

}
